(function () {
  const TRACKING_KEYS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  const STORAGE_PREFIX = 'cs_attr_';
  const COOKIE_DAYS = 90;


  function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;

    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax';
  }

  function getCookie(name) {
    const encodedName = encodeURIComponent(name) + '=';
    const parts = document.cookie.split(';');

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();

      if (part.indexOf(encodedName) === 0) {
        return decodeURIComponent(part.substring(encodedName.length));
      }
    }

    return '';
  }

  function saveValue(key, value) {
    if (!value) return;

    try {
      localStorage.setItem(STORAGE_PREFIX + key, value);
    } catch (e) {}

    setCookie(STORAGE_PREFIX + key, value, COOKIE_DAYS);
  }

  function readValue(key) {
    try {
      const localValue = localStorage.getItem(STORAGE_PREFIX + key);
      if (localValue) return localValue;
    } catch (e) {}

    return getCookie(STORAGE_PREFIX + key);
  }

  function captureUrlParams() {
    const params = new URLSearchParams(window.location.search);

    TRACKING_KEYS.forEach(function (key) {
      const value = params.get(key);

      if (value) {
        saveValue(key, value);
      }
    });

    if (!readValue('landing_page')) {
      saveValue('landing_page', window.location.href);
    }

    if (!readValue('referrer')) {
      saveValue('referrer', document.referrer || '');
    }

    if (!readValue('first_touch_timestamp')) {
      saveValue('first_touch_timestamp', new Date().toISOString());
    }
  }

  function buildCartAttributes() {
    const attributes = {};

    const mapping = {
      gclid: 'GCLID',
      gbraid: 'GBRAID',
      wbraid: 'WBRAID',
      utm_source: 'UTM Source',
      utm_medium: 'UTM Medium',
      utm_campaign: 'UTM Campaign',
      utm_term: 'UTM Term',
      utm_content: 'UTM Content'
    };

    Object.keys(mapping).forEach(function (key) {
      const value = readValue(key);

      if (value) {
        attributes[mapping[key]] = value;
      }
    });

    const landingPage = readValue('landing_page');
    const referrer = readValue('referrer');
    const timestamp = readValue('first_touch_timestamp');

    if (landingPage) attributes['Landing Page'] = landingPage;
    if (referrer) attributes['Referrer'] = referrer;
    if (timestamp) attributes['First Touch Timestamp'] = timestamp;

    return attributes;
  }

  function updateCartWithAttribution(callback) {
    const attributes = buildCartAttributes();

    if (!Object.keys(attributes).length) {
      if (typeof callback === 'function') callback();
      return;
    }

    Promise.resolve()
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: attributes
          })
        });
      })
      .then(function () {
        if (typeof callback === 'function') callback();
      })
      .catch(function (error) {
        console.warn('Google attribution cart update failed:', error);

        if (typeof callback === 'function') callback();
      });
  }

  function interceptCheckoutClicks() {
    document.addEventListener(
      'click',
      function (event) {
        const checkoutButton = event.target.closest(
          'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout-button], .rebuy-cart__checkout-button'
        );

        if (!checkoutButton) return;

        const href = checkoutButton.getAttribute('href');

        event.preventDefault();
        event.stopPropagation();

        updateCartWithAttribution(function () {
          if (href) {
            window.location.href = href;
            return;
          }

          // NOTE: form.submit() drops the clicked button's name="checkout"
          // param, so Shopify treats the POST as a cart update and 302s
          // back to /cart (infinite loop). Quantities are already AJAX-
          // synced by the theme, so navigate straight to checkout.
          window.location.href = '/checkout';
        });
      },
      true
    );
  }

  captureUrlParams();
  updateCartWithAttribution();
  interceptCheckoutClicks();
})();